import $$observable from 'symbol-observable';

// Ensure Symbol.observable is defined and consistent across Redux and DevTools
// This should run BEFORE Redux is imported anywhere.
(function ensureSymbolObservable() {
  const w = (typeof window !== 'undefined' ? (window as any) : {});
  if (typeof Symbol === 'function') {
    const current = (Symbol as any).observable;
    if (!current || current !== $$observable) {
      (Symbol as any).observable = $$observable as any;
    }
  } else {
    w.Symbol = w.Symbol || {};
    if (!w.Symbol.observable || w.Symbol.observable !== $$observable) {
      w.Symbol.observable = $$observable as any;
    }
  }
})();
